module.exports = __webpack_public_path__ + "img/gmp_white.760f9021.svg";